import { Box, Button, Grid, MenuItem, Typography } from '@mui/material';
import { DepartureInterface, IE_DEPARTURE, US_DEPARTURE, UK_DEPARTURE } from '../constants/departure';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { clearFlightRoomState, setFlightRoomState } from '../features/flightRoom/flightRoomSlice';
import {
  fetchAsyncHolidayPackages,
  setFilteredHolidayPackage,
  setHolidayPackage,
  setHolidayTypes,
  setRegionsTypes,
} from '../features/holidayPackage/holidayPackageSlice';
import AutoComplete from './AutoComplete';
import { CustomeDatePicker } from './CustomeDatePicker';
import { DateObject } from 'react-multi-date-picker';
import { DestinationList } from '../constants/Destinations';
import { ReactComponent as GuestsIcon } from '../assets/icons/Guests.svg';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
import { ReactComponent as ListingLocationIcon } from "../assets/icons/LocationListingIcon.svg";
import { ReactComponent as PlaneListIcon } from "../assets/icons/PlaneList.svg";
import { ReactComponent as SeatIcon } from "../assets/icons/SeatIcon.svg";
import { clearFlights } from '../features/holidayPackage/changeFlight';
import { colors } from '../styles/colors';
import dayjs from 'dayjs';
import { fetchAsyncDestinations } from '../features/destination/destinationSlice';
import { resetFilters, setFilterState } from '../features/filter/filterSlice';
import { setLoading } from '../features/loading/loadingSlice';
import { useAppSelector } from '../hooks/useAppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { setFindButtonClick } from '../features/findButtonClicked/findButtonClicked';
import { directFlights, directFlightsIE } from '../constants/directFlights';
import { isEmpty } from '../helpers/isEmpty';
import { capitalizeFirstLetter } from '../helpers/capitalizeFirstLetter';
import { setHolidayDetailsState } from '../features/holidaySummary/holidaySummarySlice';
import { retrieveBasket } from '../features/actions';
import CustomSelectInputListingPage from './CustomSelectInputListingPage';
import GuestDropdown from './GuestDropdown';
import useWindowWidth from '../hooks/useWindowWidth';
import { getSessionStorage, removeSessionStorage, setSessionStorage } from '../helpers/storage';
import { removeSessionElements } from '../common/removeSessionElements';
import { setLottieLoading } from '../features/lottieLoader/lottieLoader';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
// import { phoneCodeByRegionUK } from '../constants/phoneCode';
import { setEditSearch, setSelectedRegion, setShowPopup, setStorePayload } from '../features/commonState';
import { phoneCodeByRegionUK } from '../constants/phoneCodeUK';
import { phoneCodeByRegionIE } from '../constants/phoneCode';
import { getCookie } from '../helpers/cookieUtils';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ReactComponent as ArrowDownIcon } from '../assets/icons/ArrowDown.svg';
interface Room {
  room: number;
  adults: number;
  children: { child: number; age: string }[];
  infants: { child: number; age: string }[];
}

interface FindHolidayWidgetProps {
  getPosition: (p: any, b: boolean, f: boolean) => void;
  setIsClickedFilters: any;
  setIsHolidayApiCall: any;
  // setShowPopup?: any;
}

interface CABIN_CLASS_ENUM_TYPE {
  Any: string;
  Economy: string;
  Premium: string;
  'Business Class': string;
  'First Class': string;
}

const CABIN_CLASS_ENUM: CABIN_CLASS_ENUM_TYPE = {
  Any: '',
  Economy: 'M',
  Premium: 'W',
  'Business Class': 'C',
  'First Class': 'F',
};

type CabinClass = keyof typeof CABIN_CLASS_ENUM;

interface ISERROR {
  type: 'date' | 'age' | 'destination' | 'dubaiError' | 'infantAge' | 'departure' | 'guest' | 'class';
}

type LocationArrays = {
  [key: string]: string[];
};

function ErrorMessage({ type }: ISERROR) {
  return (
    <Box
      sx={{
        position: 'absolute',
        border: '1px solid #ee8369',
        zIndex: 99,
        backgroundColor: '#ee8369',
        top: '100%',
        left: '0',
        transform: 'translateY(10px)',
        '&:before': {
          content: "''",
          height: '15px',
          width: '15px',
          position: 'absolute',
          backgroundColor: '#ee8369',
          top: '-9px',
          // right: '10px',
          left: '50%',
          borderTop: `#ee8369 solid 1px`,
          borderLeft: `#ee8369 solid 1px`,
          transform: 'rotate(45deg)',
          zIndex: '9',
        },
        overflow: 'visible', // maxWidth: '200px',
      }}
    >
      <Typography
        sx={{
          p: 2,
          color: colors.basics.white,
          fontWeight: 500,
        }}
      >
        {type === 'age' && 'Please select a valid child age'}
        {/* {type === 'maxDays' && 'Please select day after 10 days from today'} */}
        {type === 'date' && 'Minimum range should be 3 nights'}
        {type === 'dubaiError' && 'Minimum range should be 3 nights'}
        {/* {type === 'dubaiError' && 'Minimum range should be 5 nights for Dubai location'} */}
        {type === 'destination' && 'Please Select Destination'}
        {type === 'infantAge' && 'Please select a valid infant age'}
        {type === 'departure' && 'Please select Departure'}
        {type === 'guest' && 'Guest should not be 0'}
        {type === "class" && "Please Select Class"}
      </Typography>
    </Box>
  );
}

export const reverseString = (str: any) => {
  var splitString = str.split("/");
  var reverseArray = splitString.reverse();
  var joinArray = reverseArray.join("/");
  return joinArray;
}


export const FindHolidayWidget: FC<FindHolidayWidgetProps> = ({ getPosition, setIsClickedFilters, setIsHolidayApiCall }) => {
  // i wnat only !isLlcFeatureRequired destinations
  const isLlcFeatureRequiredNotRequiredDestinations = DestinationList.filter(dest => !dest.isLlcFeatureRequired);
  const { flightRoom } = useAppSelector((state) => state.flightRoom);
  // const [editSearch, setEditSearch] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams();
  const { storePayload, editSearch } = useSelector((state: any) => state.commonState);
  const { holidayPackage, filteredHolidayPackage, status } = useAppSelector((state) => state.holidayPackage);
  //! Hooks
  const navigate = useNavigate()
  const [openModals, setOpenModals] = useState({
    date: false,
    departure: false,
    destination: false,
    class: false,
    room: false
  })
  const [isErrors, setIsErrors] = useState(false)

  // Ensure editSearch flips on when payload arrives (e.g., after mobile search)
  useEffect(() => {
    if (storePayload?.Packages?.results?.length > 0) {
      dispatch(setEditSearch(true));
    }
  }, [storePayload]);

  let dest: any[] = [];
  const cookieData = getCookie("sharedCookieData");
  if (cookieData) {
    try {
      const parsed = JSON.parse(decodeURIComponent(cookieData));
      dest = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      dest = [];
    }
  }
  const lastDest = dest?.length > 0 ? dest[dest.length - 1] : null;
  const [departure, setDeparture] = React.useState<DepartureInterface[]>();
  //popup condition for home and search page
  // const [selectedDestination, setSelectedDestination] = React.useState<DestinationListType>(() => {
  //   if (flightRoom?.searchCriteria?.destination) {
  //     return flightRoom.searchCriteria.destination;
  //   } else if (lastDest?.searchCriteria?.destination) {
  //     return lastDest.searchCriteria.destination;
  //   } else {
  //     return null;
  //   }
  // });

  const [selectedDestination, setSelectedDestination] = React.useState<DestinationListType>(
    flightRoom.searchCriteria.destination
  );
  const [destinationInputValue, setDestinationInputValue] = React.useState<string>('');

  const [isError, setIsError] = React.useState<ISERROR | null>(null);
  const [date, setDate] = useState<any>([]);
  const [cabin_class, set_cabin_class] = useState<CabinClass>('Economy');
  const [room, setRoom] = useState<Room[]>([]);
  const [basketId, setBasketId] = useState(searchParams.get("email") || "");
  const [firstTimeModalOpenDone, setFirstTimeModalDone] = useState({
    destination: false,
    date: false,
    room: false,
    class: false
  })
  const [rangeUpdate, setRangeUpdate] = useState(false)
  //! Refs
  //! Variables
  const dispatch = useDispatch();
  const datePickerRef = useRef<any>();
  const windowWidth = useWindowWidth()
  const adults = room?.reduce((a: number, b) => a + b?.adults, 0);
  const childrens = room?.reduce(
    (a: number, b) => a + b?.children?.filter((item: { age: string }) => Number(item?.age) >= 2)?.length || 0,
    0
  );
  const infants = room?.reduce((a: number, b) => a + b?.infants.length, 0);
  const totalChildren = room.flatMap((el: any) => el.children);
  // let destinations: string[] = DestinationList?.map(dest => `${dest["Display Name #1"]} ${dest["airport_code"]}`);
  // let destinations: string[] = DestinationList.map((des) => des['Display Name #1']);
  const selectedDeparture = departure?.find(dep => dep.selected);

  // Calculate displayText for comparison
  const displayTextForComparison = selectedDestination
    ? `${selectedDestination["Display Name #1"]} ${selectedDestination["airport_code"]}`
    : "";

  // Step 2: Filter destinations
  // When user is typing in destination field, show ALL destinations including those with restrictedDepartures
  // When user is not typing (just browsing), apply restrictedDepartures filter
  // This applies only when isLlcFeatureRequired === false (which is already filtered above)
  const isUserTyping = openModals.destination && destinationInputValue !== displayTextForComparison && destinationInputValue !== '';
  const filteredDestinations = isLlcFeatureRequiredNotRequiredDestinations.filter(dest => {
    // if no departure selected, return all destinations
    if (!selectedDeparture) return true;

    // When user is typing in the destination field, show all destinations
    if (isUserTyping) {
      return true;
    }

    // Otherwise, check if selected airport is restricted
    return !dest.restrictedDepartures?.includes(selectedDeparture.departure_airport);
  });

  let destinations: string[] = filteredDestinations?.map(dest => `${dest["Display Name #1"]} ${dest["airport_code"]}`);
  const startDate = dayjs(date[0]);
  const endDate = dayjs(date[1]);
  const hasAgeSelected = totalChildren?.every((el: any) => el.age);
  const totalInfantsChildren = room.flatMap((el: any) => el.infants);
  const hasInfantAgeSelected = totalInfantsChildren?.every((el: any) => el.age);
  const rooms = JSON.parse(getSessionStorage('room') || '{}');
  const depatureKey = getSessionStorage('more-details-click')
  const isRetrieveBasketApiCall = !window.location.search.includes("departure") && window.location.search.includes("?email") && basketId !== null && flightRoom.psw_result_id === null && getSessionStorage("more-details-click") === "false"
  const totalGuests = adults + childrens + infants
  const search = window.location.search

  //! Functions

  useEffect(() => {
    setSessionStorage("stepper", "0")
    let data = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? [...IE_DEPARTURE] : process.env.REACT_APP_PROJECT_COUNTRY === "us" ? [...US_DEPARTURE] : [...UK_DEPARTURE];
    const urlSearchParams = new URLSearchParams(search);
    const queryData: any = {};
    urlSearchParams.forEach((value, key) => {
      queryData[key] = value;
    });
    const DestinationFrom = queryData?.departure?.toUpperCase()
    // console.log('DestinationFrom :', DestinationFrom);
    const des = queryData.destinationId || null
    let destination = queryData.destination
    if (des) {
      const destinationData = isLlcFeatureRequiredNotRequiredDestinations.filter((f) => Number(des) === f["Searc ID"])
      if (destinationData.length > 0) {
        destination = destinationData[0].airport_code + "_;" + destinationData[0]["Searc ID"]
      }
    }
    // console.log('destination :', destination);
    const destinationCode = destination?.split("_")?.join("")?.toUpperCase()
    const desParts = destinationCode?.split(";");
    const desCodeName = desParts?.[0] + " ;" + desParts?.[1];
    const desCode = desCodeName && !desCodeName.includes("undefined")
      ? desCodeName
      : `${flightRoom?.searchCriteria?.destination?.airport_code?.toUpperCase() || ""} ;${flightRoom?.searchCriteria?.destination?.["Searc ID"] || ""}`;


    const desFilter = isLlcFeatureRequiredNotRequiredDestinations?.filter((f) => {
      return f.airport_code.toUpperCase() + " ;" + f["Searc ID"] === desCode;
    });

    if (flightRoom?.searchCriteria?.destination || desCodeName) {

      data = data.filter(item => !desFilter?.[0]?.restrictedDepartures?.includes(item.departure_airport));
    }
    data = data.map((item: any, index: number) => {
      return {
        ...item,
        selected: depatureKey === 'true' ? flightRoom.searchCriteria.departure.full_name === item.full_name : index === 0 ? true : false,
      };
    });
    setDeparture(data || []);
  }, [depatureKey]);

  useEffect(() => {
    if (Object.keys(rooms).length > 0) {
      const roomArr = [...rooms.room]
      roomArr.map((r: any) => {
        if (r.infants === undefined || r.infants === 0) {
          r.infants = []
        }
        return r
      })
      setRoom(roomArr);
      setDate([new DateObject(new Date(rooms.date[0])), new DateObject(new Date(rooms.date[1]))]);
    } else {
      setRoom([
        {
          room: 1,
          adults: 2,
          children: [],
          infants: []
        },
      ]);

      const currentDate = dayjs();
      const startDate = currentDate.add(1, 'month');
      const endDate = startDate.add(7, 'days');
      const date = [
        new DateObject(dayjs(startDate).format("YYYY/MM/DD")),
        new DateObject(dayjs(endDate).format("YYYY/MM/DD"))
      ];
      setDate(date)
    }
    set_cabin_class(flightRoom.searchCriteria.class as CabinClass)
  }, []);

  useEffect(() => {
    if (totalGuests > 0 && isError?.type === "guest") {
      setIsError(null);
    }
  }, [totalGuests, isError])

  useEffect(() => {
    if (hasAgeSelected && isError?.type === "age") {
      setIsError(null);
    }
  }, [hasAgeSelected, isError]);

  useEffect(() => {
    if (hasInfantAgeSelected && isError?.type === "infantAge") {
      setIsError(null);
    }
  }, [hasInfantAgeSelected, isError])

  useEffect(() => {
    if (!destinations?.length) {
      dispatch(fetchAsyncDestinations([]));
    }
  }, []);

  // Reset destination input value when dropdown closes
  useEffect(() => {
    if (!openModals.destination) {
      setDestinationInputValue('');
    }
  }, [openModals.destination]);

  // useEffect(() => {
  //   if (!isErrors) {
  //     onDateConfirm();
  //   }
  // }, [date, isErrors]);

  useEffect(() => {
    if (isRetrieveBasketApiCall) {
      retrieveDB()
    }
  }, [basketId, window.location.search, getSessionStorage("more-details-click"), flightRoom.psw_result_id])

  useEffect(() => {
    if (((search.includes("departure") || search.includes("destination")))) {
      const urlSearchParams = new URLSearchParams(search);
      const queryData: any = {};
      urlSearchParams.forEach((value, key) => {
        queryData[key] = value;
      });

      if (getSessionStorage("apiCall") !== "true") {
        dispatch(setShowPopup(false))
        dispatch(setLottieLoading(true))
      }
      setTimeout(() => {
        renderOnLoadHolidayPackageApi(queryData)
      }, 1)
    }
  }, [])

  // useEffect(() => {
  //     const query = window.location.search;
  //     if (getSessionStorage('basketId')) {
  //       const storedBasketId = getSessionStorage("basketId");
  //     setBasketId(storedBasketId)
  //     } else if (query.includes("?email") || query.includes("?bid")) {
  //       setBasketId(query.replace("?email=", "").replace("?bid=", ""));
  //     } else {
  //       setBasketId(null);
  //     }
  //   }, [getSessionStorage('basketId'), window.location.search]);

  //Data get from the URL
  useEffect(() => {
    const query = window.location.search;
    // if (getSessionStorage('basketId')) {
    //   const storedBasketId = getSessionStorage("basketId");
    // setBasketId(storedBasketId)
    // } else
    if (query.includes("?email")) {
      setBasketId(query.replace("?email=", ""));
    } else {
      setBasketId('');
    }
  }, [window.location.search]);

  // useEffect(() => {
  //   if (getSessionStorage("basketId")) {
  //     const storedBasketId = getSessionStorage("basketId");
  //     setBasketId(storedBasketId)
  //   } else if (window.location.search.includes("?email")) {
  //     setBasketId(window.location.search.replace("?email=", ""))
  //   } else {
  //     setBasketId(null)
  //   }
  // }, [getSessionStorage("basketId"), window.location.search])

  useEffect(() => {
    if ((!search.includes("departure") && !search.includes("destination")) && flightRoom.psw_result_id !== null && getSessionStorage("apiCall") !== "true") {
      dispatch(setShowPopup(false))
      dispatch(setLottieLoading(true))
      setSessionStorage("apiCall", "true")
      basketId === null ? initialHolidayPackageSearchApi(flightRoom, "0") : initialHolidayPackageSearchApi(flightRoom, basketId)
    }
  }, [basketId, selectedDestination, flightRoom.psw_result_id, getSessionStorage("apiCall")])

  const renderOnLoadHolidayPackageApi = async (queryData: any) => {
    await dispatch(setShowPopup(false))
    // html page and payment microsite when comes on refresh
    removeSessionElements()
    getPosition(undefined, true, false)
    const adult = queryData.adult.split(",")
    const cabinClass: CabinClass = capitalizeFirstLetter(queryData.cabin_class.split("_").join(" ")) as CabinClass
    const child_age = queryData?.child_age && queryData?.child_age?.length > 0 ? JSON.parse(queryData.child_age) : []
    const children = queryData.children_count.split(",")
    const startDate = queryData.daterange.split(",")[0]
    const endDate = queryData.daterange.split(",")[1]
    let destination = queryData.destination
    const infantAge = (queryData.infant_age && queryData.infant_age !== 'undefined' && queryData.infant_age.length > 0) ? JSON.parse(queryData.infant_age) : []
    const infantCount = queryData.infant_count.split(",")
    const roomCount = queryData.room_count
    const DestinationFrom = queryData.departure.toUpperCase()
    const des = queryData.destinationId || null

    if (des) {
      const destinationData = isLlcFeatureRequiredNotRequiredDestinations.filter((f) => Number(des) === f["Searc ID"])
      if (destinationData.length > 0) {
        destination = destinationData[0].airport_code + "_;" + destinationData[0]["Searc ID"]
      }
    }
    // if (destination === undefined) {
    //   dispatch(setLottieLoading(true))
    //   navigate('/')
    //   dispatch(setLottieLoading(false))
    // }
    const destinationCode = destination.split("_").join("").toUpperCase()
    const desParts = destinationCode?.split(";");
    const desCodeName = desParts[0] + " ;" + desParts[1];

    let isDirectFlight: boolean = false

    if (process.env.REACT_APP_PROJECT_COUNTRY === "ie") {
      directFlightsIE.map((d: any) => {
        if (d.dep_code === DestinationFrom && d.des_code === isEmpty(desCodeName)?.toUpperCase()) {
          isDirectFlight = true
          return d
        } else {
          return <></>
        }
      })
    } else if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
      directFlights.map((d: any) => {
        if (d.dep_code === DestinationFrom && d.des_code === isEmpty(desCodeName)?.toUpperCase()) {
          isDirectFlight = true
          return d
        } else {
          return <></>
        }
      })
    }

    // Set Rooms 
    let roomArr: any = []
    for (let i = 0; i < Number(roomCount); i++) {
      let childArr: any = []
      let infantArr: any = []

      for (let j = 0; j < Number(children[i]); j++) {
        let child = {
          child: j + 1,
          age: Number(child_age[i][j + 1])
        }

        childArr.push(child)
      }

      for (let j = 0; j < Number(infantCount[i]); j++) {
        let child = {
          child: j + 1,
          age: Number(infantAge[i][j + 1])
        }

        infantArr.push(child)
      }

      let obj = {
        room: i + 1,
        adults: Number(adult[i]),
        children: childArr,
        infants: infantArr
      }
      roomArr.push(obj)
    }
    setRoom(roomArr)
    // Set Cabin Class 
    set_cabin_class(cabinClass)

    // Set Departure 
    const dep = setInitialDeparture(DestinationFrom, true)

    // Set Dates 
    const date = [
      new DateObject(dayjs(reverseString(startDate)).format("YYYY/MM/DD")),
      new DateObject(dayjs(reverseString(endDate)).format("YYYY/MM/DD"))
    ]
    setDate(date);

    // Set Destination
    const selectedDestination = isLlcFeatureRequiredNotRequiredDestinations.filter((f) => f.airport_code.toUpperCase() + ";" + f["Searc ID"] === destinationCode)
    setSelectedDestination(selectedDestination[0])

    // set individual adults , infants and childrens
    const adults = roomArr?.reduce((a: number, b: any) => a + b?.adults, 0);
    const childrens = roomArr?.reduce(
      (a: number, b: any) => a + b?.children?.filter((item: { age: string }) => Number(item?.age) >= 2)?.length || 0,
      0
    );
    const infants = roomArr?.reduce((a: number, b: any) => a + b?.infants.length, 0);
    let totalGuests = adults + childrens + infants

    const date1: any = new Date(reverseString(startDate));
    const date2: any = new Date(reverseString(endDate));

    const timeDifference = date2 - date1;

    let nights = timeDifference / (1000 * 60 * 60 * 24);
    nights = Math?.floor(nights);
    const isDubai = selectedDestination.length > 0 ? selectedDestination[0]['Display Name #1'].includes('Dubai') : false;

    const totalChildren = roomArr.flatMap((el: any) => el.children);
    const hasAgeSelected = totalChildren?.every((el: any) => el.age);
    const totalInfantsChildren = roomArr.flatMap((el: any) => el.infants);
    const hasInfantAgeSelected = totalInfantsChildren?.every((el: any) => el.age);

    let isError = false
    if (DestinationFrom === "") {
      isError = true
      setIsErrors(true)
      setIsError({ type: 'departure' });
    } else if (selectedDestination.length === 0) {
      isError = true
      setIsErrors(true)
      setIsError({ type: 'destination' });
    } else if (!(nights >= 3)) {
      isError = true
      setIsErrors(false)
      setIsError({ type: 'date' });
    }
    // else if (isDubai === true && !(nights >= 3)) {
    //   console.log('helo');

    //   isError = true
    //   setIsErrors(false)
    //   setIsError({ type: 'date' });
    // }
    else if (!hasAgeSelected) {
      setIsErrors(true)
      isError = true
      setIsError({ type: 'age' });
    } else if (!hasInfantAgeSelected) {
      setIsErrors(true)
      isError = true
      setIsError({ type: 'infantAge' });
    } else if (totalGuests === 0) {
      setIsErrors(true)
      setIsError({ type: 'guest' });
      isError = true
    } else if (isEmpty(cabinClass) === "") {
      isError = true
      setIsErrors(true)
      setIsError({ type: 'class' });
    } else if (roomCount === "") {
      isError = true
      setIsErrors(true)
      setIsError({ type: 'guest' });
    } else if (queryData.adult === "") {
      isError = true
      setIsErrors(true)
      setIsError({ type: 'guest' });
    } else {
      setIsErrors(false)
      isError = false
      setIsError(null);
    }
    if (hasAgeSelected && hasInfantAgeSelected && selectedDestination.length > 0 && !isError && getSessionStorage("apiCall") !== "true") {
      setSessionStorage("apiCall", true)
      // dispatch(setLoading(true))
      dispatch(setIsHolidayApiCall(true))
      let body: any = [
        {
          DestinationFrom,
          Destination: selectedDestination.length > 0 ? selectedDestination[0].airport_code?.toUpperCase() + " ;" + selectedDestination[0]['Searc ID'] : "",
          departure_date: startDate,
          rooms: roomCount,
          nights: String(nights),
          cabin_class: CABIN_CLASS_ENUM[cabinClass],
          adults: adult,
          children: children,
          infants: infantCount,
          siteId: process.env.REACT_APP_SITE_ID,
          only_it_fares: true,
          cheapestFareCat: 'IT',
          direct_flight_only: isDirectFlight ? 1 : 0,
          basketId: "0",
          only_pu_fares: false,
          only_ss_fares: false,

        },
      ];

      if (childrens !== 0) {
        body[0].child_age = child_age
      }

      if (infants !== 0) {
        body[0].infant_ages = infantAge
      }

      setSessionStorage('search', JSON.stringify(body));
      setSessionStorage('room', JSON.stringify({ room: roomArr, date }));

      if (queryData.UAT !== '0') {
        const { payload } = await dispatch(fetchAsyncHolidayPackages(body));
        if (payload === undefined || payload?.Packages?.results?.length === 0) {
          // navigate('/')
          dispatch(setShowPopup(true))
        } else {
          dispatch(setShowPopup(false))
          // navigate("/holiday-search")
        }
        dispatch(setStorePayload(payload))
        const selectedDeparture = dep.filter((f) => f?.selected)
        const { depart_airport_name, departure_airport, full_name } = selectedDeparture[0];
        // dispatch(setHolidayPackage(payload));
        // console.log("ISSUE---32")
        if (payload?.Packages) {
          dispatch(setEditSearch(true))
          dispatch(
            setFlightRoomState({
              ...flightRoom,
              packageSearchId: payload?.packageSearchId || "",
              flightSearchCriteriaId: payload?.SearchCriteria?.[1].ids.flightSearchCriteriaId,
              hotelSearchCriteriaIds: payload.SearchCriteria?.[1].ids.hotelSearchCriteriaIds,
              hotelSearchCriteriaId_nextDay: payload.SearchCriteria?.[1].ids.hotelSearchCriteriaId_nextDay,
              searchCriteria: {
                child_age: child_age,
                departure: {
                  depart_airport_name,
                  departure_airport,
                  full_name,
                  selected: true,
                },
                isAdditionalTransferAmountAdd: selectedDestination.length > 0 ? selectedDestination[0]?.transfer_add : false,
                destination: selectedDestination[0],
                date: [startDate, endDate],
                guest: roomArr,
                class: cabin_class,
                night: nights,
                adults,
                childrens,
                infants,
              }
            })
          );
          dispatch(setHolidayPackage(payload));
          if (payload?.Packages?.results.length > 0) {
            setSessionStorage("transferApiCall", "true")
          } else {
            dispatch(setLottieLoading(false))
            dispatch(setLoading(false))
            setSessionStorage("transferApiCall", "false")
          }
          // dispatch(setLoading(false))
          getPosition(payload, true, false)
        } else {
          setSessionStorage("transferApiCall", "false")
          dispatch(setHolidayPackage({}));
          dispatch(setLoading(false))
          getPosition({}, true, false)
          dispatch(setLottieLoading(false))
        }
      } else {
        dispatch(setLoading(false))
        dispatch(setLottieLoading(false))
      }
    }
  }

  const handleFind = async () => {
    dispatch(setShowPopup(false))
    navigate(window.location.pathname, { replace: true });
    setBasketId('')
    removeSessionElements()
    setSessionStorage("click", "true")
    setSessionStorage("apiCall", "true")
    setSessionStorage("folderApiCall", "false")
    removeSessionStorage("passenger-info")
    if (!openModals.date) {
      const numberOfNights = endDate.diff(startDate, 'day');
      const isDubai = selectedDestination && selectedDestination['Display Name #1'].includes('Dubai');
      let error = false
      if (!selectedDestination) {
        setIsError({ type: 'destination' });
        error = true
      } else if (isDubai === false && !(numberOfNights >= 3)) {
        setIsError({ type: 'date' });
        error = true
      } else if (!hasAgeSelected) {
        setIsError({ type: 'age' });
        error = true
      } else if (!hasInfantAgeSelected) {
        setIsError({ type: 'infantAge' });
        error = true
      } else if (totalGuests === 0) {
        setIsErrors(true)
        setIsError({ type: 'guest' });
        error = true
      } else if (isEmpty(cabin_class) === "") {
        setIsErrors(true)
        setIsError({ type: 'class' });
        error = true
      } else {
        setIsError(null);
        error = false
      }

      if (hasAgeSelected && hasInfantAgeSelected && selectedDestination?.airport_code && !error) {
        dispatch(setIsHolidayApiCall(true))
        dispatch(setLottieLoading(true))
        dispatch(setIsClickedFilters(false))
        getPosition(undefined, true, false)
        dispatch(setHolidayPackage({}));
        // console.log("ISSUE---33")
        dispatch(setFlightRoomState({}))
        dispatch(setFilterState({
          holidayType: [],
          starRating: [],
          hotelName: '',
          price: [],
          sorting: 'Popularity',
          regionType: [],
        }))
        dispatch(setFilteredHolidayPackage({}))
        dispatch(setHolidayTypes([]))
        dispatch(setRegionsTypes([]))
        dispatch(setFindButtonClick(true))

        dispatch(clearFlights());
        dispatch(clearFlightRoomState());
        // dispatch(setLoading(true));
        dispatch(resetFilters());
        // dispatch(clearHolidayPackageState());

        const DestinationFrom = departure?.find((item: any) => item.selected)?.departure_airport;
        const departure_date = dayjs(date[0]).format("DD/MM/YYYY")
        const adultPerRoom: any = []
        const childPerRoom: any = []
        const childAge: any = [];
        const infantAge: any = []
        const infantPerRoom: any = [];

        if (room.length > 0) {
          room?.map((r: any) => {
            adultPerRoom.push(r.adults.toString())
            childPerRoom.push(r.children.length.toString())
            infantPerRoom.push(r.infants.length.toString())
            const childrenAges: any = {};
            const infantsAges: any = {};

            if (r?.children?.length > 0) {
              r?.children.forEach((child: any) => {
                childrenAges[child.child.toString()] = child.age;
              });
              childAge.push(childrenAges);
            } else {
              childAge.push({});
            }

            if (r?.infants?.length > 0) {
              r?.infants.forEach((child: any) => {
                infantsAges[child.child.toString()] = child.age;
              });
              infantAge.push(infantsAges);
            } else {
              infantAge.push({});
            }

            return r
          })
        }

        let isDirectFlight: boolean = false
        const desCode = `${selectedDestination?.airport_code} ;${selectedDestination?.['Searc ID']}`

        if (process.env.REACT_APP_PROJECT_COUNTRY === "ie") {
          directFlightsIE.map((d: any) => {
            if (d.dep_code === DestinationFrom && d.des_code === isEmpty(desCode)?.toUpperCase()) {
              isDirectFlight = true
              return d
            } else {
              return <></>
            }
          })
        } else if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
          directFlights.map((d: any) => {
            if (d.dep_code === DestinationFrom && d.des_code === isEmpty(desCode)?.toUpperCase()) {
              isDirectFlight = true
              return d
            } else {
              return <></>
            }
          })
        }

        // directFlights.map((d: any) => {
        //   if (d.dep_code === DestinationFrom && d.des_code === isEmpty(selectedDestination?.airport_code.toUpperCase())) {
        //     isDirectFlight = true
        //     return d
        //   } else {
        //     return <></>
        //   }
        // })

        let body: any = [
          {
            DestinationFrom,
            Destination: `${selectedDestination.airport_code.toUpperCase()} ;${selectedDestination?.['Searc ID']}`,
            departure_date,
            rooms: String(room?.length),
            nights: String(numberOfNights),
            cabin_class: CABIN_CLASS_ENUM[cabin_class],
            adults: adultPerRoom,
            children: childPerRoom,
            infants: infantPerRoom,
            siteId: process.env.REACT_APP_SITE_ID,
            only_it_fares: true,
            cheapestFareCat: 'IT',
            direct_flight_only: isDirectFlight ? 1 : 0,
            basketId: "0",
            only_pu_fares: false,
            only_ss_fares: false,
          },
        ];

        if (childrens !== 0) {
          body[0].child_age = childAge
        }

        if (infants !== 0) {
          body[0].infant_ages = infantAge
        }

        setSessionStorage('search', JSON.stringify(body));
        setSessionStorage('room', JSON.stringify({ room, date }));

        const { payload } = await dispatch(fetchAsyncHolidayPackages(body));
        dispatch(setStorePayload(payload))
        if (payload?.Packages?.results?.length > 0) {
          dispatch(setEditSearch(true))
        }
        const dep:
          | {
            depart_airport_name: string;
            departure_airport: string;
            full_name: string;
          }
          | undefined = departure?.find((item) => item.selected);
        if (dep) {
          const { depart_airport_name, departure_airport, full_name } = dep;
          // console.log("ISSUE---34")
          dispatch(setFlightRoomState({
            ...flightRoom,
            packageSearchId: payload?.packageSearchId || "",
            flightSearchCriteriaId: payload?.SearchCriteria?.[1].ids.flightSearchCriteriaId,
            hotelSearchCriteriaIds: payload?.SearchCriteria?.[1].ids.hotelSearchCriteriaIds,
            hotelSearchCriteriaId_nextDay: payload?.SearchCriteria?.[1].ids.hotelSearchCriteriaId_nextDay,
            searchCriteria: {
              child_age: childAge,
              infant_age: infantAge,
              departure: {
                depart_airport_name,
                departure_airport,
                full_name,
                selected: true,
              },
              isAdditionalTransferAmountAdd: selectedDestination?.transfer_add,
              destination: selectedDestination,
              date: [dayjs(date[0]).format("DD/MM/YYYY"), dayjs(date[1]).format("DD/MM/YYYY")],
              guest: room,
              class: cabin_class,
              night: numberOfNights,
              adults,
              childrens,
              infants,
            },
          }));
        } else {
          console.log('Invalid Departure', dep);
        }

        if (payload?.Packages) {
          dispatch(setHolidayPackage(payload));
          if (payload?.Packages?.results.length > 0) {
            setSessionStorage("transferApiCall", "true")
          } else {
            dispatch(setLottieLoading(false))
            dispatch(setLoading(false))
            setSessionStorage("transferApiCall", "false")
            dispatch(setLoading(false))
          }
          getPosition(payload, true, false)
        } else {
          dispatch(setLottieLoading(false))
          setSessionStorage("transferApiCall", "false")
          dispatch(setHolidayPackage({}));
          dispatch(setLoading(false))
          getPosition({}, true, false)
        }
        if (payload === undefined || payload?.Packages?.results?.length === 0) {
          navigate('/')
          dispatch(setShowPopup(true))
        } else {
          dispatch(setShowPopup(false))
          navigate("/holiday-search")
        }
      }
    }
  };

  const handleOnChangeDestination = async (value: string, selectedDepartureData?: DepartureInterface) => {
    const selectedDest: DestinationListType | undefined = isLlcFeatureRequiredNotRequiredDestinations.find(
      (item) => `${item["Display Name #1"]} ${item["airport_code"]}` === value
    );

    // setFirstTimeModalDone({
    //   ...firstTimeModalOpenDone, destination: true
    // })

    // if (!firstTimeModalOpenDone.date) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       destination: false,
    //       // date: true
    //     })
    //     datePickerRef.current.openCalendar()
    //   }, 50)
    // } else if (!firstTimeModalOpenDone.class) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       destination: false,
    //       // class: true
    //     })
    //   }, 10)
    // } else if (!firstTimeModalOpenDone.room) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       destination: false,
    //       // room: true
    //     })
    //   }, 10)
    // } else {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       destination: false,
    //     })
    //   }, 10)
    // }

    if (selectedDest) {
      setSelectedDestination(selectedDest);
      onDateConfirm();
      // console.log("ISSUE---35")
      dispatch(
        setFlightRoomState({
          ...flightRoom,
          searchCriteria: {
            ...flightRoom.searchCriteria,
            destination: selectedDest,
            departure: selectedDepartureData || flightRoom.searchCriteria.departure,
            adults,
            childrens,
            infants,
          },
        })
      );
      const numberOfNights = endDate.diff(startDate, 'day');
      const isDubai = selectedDest && selectedDest['Display Name #1'].includes('Dubai');
      if (isDubai && !(numberOfNights >= 3)) {
        setIsError({ type: 'dubaiError' });
      } else if (isDubai === false && !(numberOfNights >= 3)) {
        setIsError({ type: 'date' });
      } else {
        setIsError(null);
      }
    }
  };

  const retrieveDB = async () => {
    dispatch(setLottieLoading(true))
    let res = await dispatch(retrieveBasket(basketId));
    res = res.payload;

    let data: any = {}
    if (res?.data?.length > 0) {
      data = res.data[0]
      const flightData: any = JSON.parse(
        Object.values(data.basket.cart.flights)[0] as string
      );
      removeSessionElements()
      const holidayData: any = JSON.parse(data.basket.cart.holiday);
      // console.log("ISSUE---36")
      dispatch(setFlightRoomState(flightData));
      dispatch(setHolidayDetailsState(holidayData));
      // initialHolidayPackageSearchApi(flightData, basketId)
      // dispatch(setLoading(false));
    } else {
      dispatch(setLottieLoading(false))
      dispatch(setLoading(false));
    }
  }

  const initialHolidayPackageSearchApi = async (flightRoom: any, basketId: any) => {
    dispatch(setShowPopup(false))
    dispatch(setLottieLoading(true))
    const DestinationFrom = flightRoom.searchCriteria.departure.departure_airport
    const destinationCode = flightRoom.searchCriteria.destination.airport_code
    const adultPerRoom: any = []
    const childPerRoom: any = []
    const childAge: any = [];
    const cabinClass: CabinClass = flightRoom.searchCriteria.class
    const room = flightRoom.searchCriteria.guest
    const childrens = room?.reduce(
      (a: number, b: any) => a + b?.children?.filter((item: { age: string }) => Number(item?.age) >= 2)?.length || 0,
      0
    );
    const infants = room?.reduce((a: number, b: any) => a + b?.infants.length, 0);
    const infantAge: any = []
    const infantPerRoom: any = [];

    if (room.length > 0) {
      room?.map((r: any) => {
        adultPerRoom.push(r.adults.toString())
        childPerRoom.push(r.children.length.toString())
        infantPerRoom.push(r.infants.length.toString())
        const childrenAges: any = {};
        const infantsAges: any = {};

        if (r?.children?.length > 0) {
          r?.children.forEach((child: any) => {
            childrenAges[child.child.toString()] = child.age;
          });
          childAge.push(childrenAges);
        } else {
          childAge.push({});
        }

        if (r?.infants?.length > 0) {
          r?.infants.forEach((child: any) => {
            infantsAges[child.child.toString()] = child.age;
          });
          infantAge.push(infantsAges);
        } else {
          infantAge.push({});
        }

        return r
      })
    }

    let isDirectFlight: boolean = false

    if (process.env.REACT_APP_PROJECT_COUNTRY === "ie") {
      directFlightsIE.map((d: any) => {
        if (d.dep_code === DestinationFrom && d.des_code === isEmpty(destinationCode.toUpperCase())) {
          isDirectFlight = true
          return d
        } else {
          return <></>
        }
      })
    } else if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
      directFlights.map((d: any) => {
        if (d.dep_code === DestinationFrom && d.des_code === isEmpty(destinationCode.toUpperCase())) {
          isDirectFlight = true
          return d
        } else {
          return <></>
        }
      })
    }

    let body: any = [
      {
        DestinationFrom,
        Destination: `${flightRoom.searchCriteria.destination.airport_code?.toUpperCase()} ;${flightRoom.searchCriteria.destination?.['Searc ID']}`,
        departure_date: flightRoom.searchCriteria.date[0],
        rooms: flightRoom.searchCriteria.guest.length.toString(),
        nights: String(flightRoom.searchCriteria.night),
        cabin_class: CABIN_CLASS_ENUM[cabinClass],
        adults: adultPerRoom,
        children: childPerRoom,
        infants: infantPerRoom,
        siteId: process.env.REACT_APP_SITE_ID,
        only_it_fares: true,
        cheapestFareCat: 'IT',
        direct_flight_only: isDirectFlight ? 1 : 0,
        basketId: basketId,
        only_pu_fares: false,
        only_ss_fares: false,
      },
    ];

    if (basketId !== "0") {
      body[0].packageSearchId = flightRoom.packageSearchId
    }

    if (childrens !== 0) {
      body[0].child_age = childAge
    }


    if (infants !== 0) {
      body[0].infant_ages = infantAge
    }

    setInitialDeparture(flightRoom.searchCriteria.departure.full_name)
    setSelectedDestination(flightRoom.searchCriteria.destination)

    setDate([
      new DateObject(dayjs(reverseString(flightRoom.searchCriteria.date[0])).format("YYYY/MM/DD")),
      new DateObject(dayjs(reverseString(flightRoom.searchCriteria.date[1])).format("YYYY/MM/DD"))
    ]);

    const date = [
      new DateObject(dayjs(reverseString(flightRoom.searchCriteria.date[0])).format("YYYY/MM/DD")),
      new DateObject(dayjs(reverseString(flightRoom.searchCriteria.date[1])).format("YYYY/MM/DD"))
    ]
    dispatch(setIsHolidayApiCall(true))
    setSessionStorage('search', JSON.stringify(body));
    setSessionStorage('room', JSON.stringify({ room, date }));
    setRoom(room)
    set_cabin_class(flightRoom.searchCriteria.class)
    setSessionStorage('search', JSON.stringify(body));
    setSessionStorage('room', JSON.stringify({ room, date }));
    // if (Object.keys(holidayPackage).length === 0) {
    // dispatch(setLoading(true));
    const { payload } = await dispatch(fetchAsyncHolidayPackages(body));
    dispatch(setStorePayload(payload))
    if (payload === undefined || payload?.Packages?.results?.length === 0) {
      navigate('/')
      dispatch(setShowPopup(true))
    } else {
      dispatch(setShowPopup(false))
      // navigate("/holiday-search")
    }
    if (payload) {
      dispatch(setEditSearch(true))
      // console.log("ISSUE---37")
      setFlightRoomState({
        ...flightRoom,
        packageSearchId: payload?.packageSearchId || "",
        flightSearchCriteriaId: payload.SearchCriteria[1].ids.flightSearchCriteriaId,
        hotelSearchCriteriaIds: payload.SearchCriteria[1].ids.hotelSearchCriteriaIds,
        hotelSearchCriteriaId_nextDay: payload.SearchCriteria[1].ids.hotelSearchCriteriaId_nextDay,
      })
      setSessionStorage("transferApiCall", "true")
      setSessionStorage("isChangeFlightDone", "false")
      dispatch(setHolidayPackage(payload));
    } else {
      dispatch(setLottieLoading(false))
    }

    // }
  }

  const handleSetDeparture = (e: string) => {
    const d = departure?.map((item) => ({
      ...item,
      selected: item.full_name === e,
    }));

    setDeparture(d);
    if (d && d.length > 0) {
      // Remove the .dropdown-menu.show class
      const dropdownMenu = document.querySelector('.dropdown-menu.show');
      if (dropdownMenu) {
        dropdownMenu.classList.remove('show');
      }
    }

  };

  const classOptions = Object.keys(CABIN_CLASS_ENUM);

  const DepartureDropdownContent = ({ closeDropdown }: { closeDropdown?: () => void }) => (
    <Box borderRadius='3px' position='relative' sx={{

    }}  >
      <Box
        sx={{

          position: "sticky",
          top: 0,
          zIndex: 2,
          background: colors.basics.white,
          borderBottom: `1px solid${colors.grey[50]}`,
          padding: "8px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "4px",
        }}
      >
        <Box display="flex" alignItems="center" gap="4px" fontSize={{ sm: "15px", xs: "14px" }}>
          <PlaneListIcon />
          {(() => {
            const departureName = departure?.find(({ selected }) => selected)?.full_name || '';
            if (departureName.length > 3) {
              const normalText = departureName.slice(0, -3);
              const boldText = departureName.slice(-3);
              return (
                <>
                  {normalText}
                  <strong>{boldText}</strong>
                </>
              );
            }
            return departureName;
          })()}
        </Box>
        <CloseRoundedIcon onClick={() => closeDropdown?.()} sx={{ cursor: 'pointer' }} />
      </Box>
      <Box
        sx={{
          maxHeight: 260,
          overflowY: "auto",
          padding: "10px !important",
        }}
      >
        {/* <Typography
          variant="body2"
          fontSize={{ sm: "15px", xs: "14px" }}
          fontWeight={400}
          color={colors.grey[10]}
          sx={{ mb: "16px", mt: '8px', display: "block" }}
        >
          Airports for departure
        </Typography> */}
        {departure.map(
          ({ depart_airport_name, departure_airport, full_name }: any, index: number) => {
            const val = departure.find(({ selected }) => selected)?.full_name || "";
            return (
              <MenuItem
                sx={{
                  padding: "8px 8px !important",
                  my: "2px",
                  background:
                    val === full_name
                      ? colors.basics.pink + "!important"
                      : colors.basics.white,
                  borderRadius: val === full_name ? "5px!important" : "unset",
                }}
                key={index}
                value={full_name}
                onClick={() => {
                  if (isError?.type === "departure") {
                    setIsError(null);
                  }
                  setIsErrors(false);
                  handleSetDeparture(full_name);
                }}
              >
                <Typography variant="body2" display="flex" alignItems="center" gap="4px" fontSize={{ sm: "15px", xs: "14px" }} fontWeight={400} lineHeight="16px" color={colors.grey[10]}>
                  {/* <PlaneListIcon /> */}
                  {depart_airport_name} <b>{departure_airport}</b>
                </Typography>
              </MenuItem>
            );
          }
        )}
      </Box>
    </Box>
  );

  const ClassDropdownContent = ({ closeDropdown }: { closeDropdown?: () => void }) => (
    <>
      <Box
        sx={{
          padding: "8px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "4px",
          borderBottom: `1px solid${colors.grey[50]}`,
          background: colors.basics.white,
        }}
      >
        <Box display="flex" alignItems="center" gap="6px" fontWeight={400} fontSize={{ sm: "15px", xs: "14px" }}>
          <SeatIcon /> {cabin_class}
        </Box>
        <CloseRoundedIcon onClick={() => closeDropdown?.()} sx={{ cursor: 'pointer' }} />
      </Box>
      <Box
        sx={{
          maxHeight: 260,
          overflowY: "auto",
          padding: "8px !important",
        }}
      >
        {/* <Typography
          variant="body2"
          fontSize={{ sm: "15px", xs: "14px" }}
          fontWeight={400}
          color={colors.grey[10]}
          sx={{ mb: "8px", mt: '8px', display: "block" }}
        >
          Cabin class
        </Typography> */}
        {classOptions.map((item) => (
          <MenuItem
            key={item}
            value={item}
            onClick={() => {
              handleSelectClass(item);
              closeDropdown?.();
            }}
            sx={{
              padding: "8px 8px !important",
              my: "2px",
              background:
                cabin_class === item
                  ? colors.basics.pink + "!important"
                  : colors.basics.white,
              borderRadius: cabin_class === item ? "5px!important" : "unset",
            }}
          >
            <Typography variant="body2" display="flex" alignItems="center" gap="6px" fontSize={{ sm: "15px", xs: "14px" }} fontWeight={400} lineHeight="16px" color={colors.grey[10]}>
              {/* <SeatIcon />  */}
              {item}
            </Typography>
          </MenuItem>
        ))}
      </Box>
    </>
  );

  const setInitialDeparture = (e: string[] = [], code?: boolean) => {

    let data = process.env.REACT_APP_PROJECT_COUNTRY === "ie"
      ? [...IE_DEPARTURE]
      : process.env.REACT_APP_PROJECT_COUNTRY === "us"
        ? [...US_DEPARTURE]
        : [...UK_DEPARTURE];
    const urlSearchParams = new URLSearchParams(search);
    const queryData: any = {};
    urlSearchParams.forEach((value, key) => {
      queryData[key] = value;
    });

    const des = queryData.destinationId || null
    let destination = queryData.destination
    if (des) {
      const destinationData = isLlcFeatureRequiredNotRequiredDestinations.filter((f) => Number(des) === f["Searc ID"])
      if (destinationData.length > 0) {
        destination = destinationData[0].airport_code + "_;" + destinationData[0]["Searc ID"]
      }
    }
    const destinationCode = destination?.split("_")?.join("")?.toUpperCase()
    const desParts = destinationCode?.split(";");
    const desCodeName = desParts?.[0] + " ;" + desParts?.[1];

    const desCode = desCodeName && !desCodeName.includes("undefined")
      ? desCodeName
      : `${flightRoom?.searchCriteria?.destination?.airport_code?.toUpperCase() || ""} ;${flightRoom?.searchCriteria?.destination?.["Searc ID"] || ""}`;

    const desFilter = isLlcFeatureRequiredNotRequiredDestinations?.filter((f) => {
      return f.airport_code.toUpperCase() + " ;" + f["Searc ID"] === desCode;
    });

    // filter restricted airports

    if (desFilter) {

      data = data.filter(item => !desFilter?.[0]?.restrictedDepartures?.includes(item.departure_airport));
    }
    data = data.map((item, index) => {
      return {
        ...item,
        selected: index === 0 ? true : false,
      };
    });
    // override selection if explicit e is passed
    // if (e) {
    data = data?.map((item) => {
      code === true ? item.departure_airport === e ? (item.selected = true) : (item.selected = false) : item.full_name === e ? (item.selected = true) : (item.selected = false);
      return item;
    });
    // }

    setDeparture(data);
    return data;
  };

  const guestRoomSubmit = () => {
    // let obj: any = { ...firs tTimeModalOpenDone }
    // obj["room"] = true
    // setFirstTimeModalDone(obj)
    // if (selectedDestination === null) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       room: false,
    //       // destination: true
    //     })
    //   }, 100)
    // } else {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       room: false,
    //     })
    //   }, 100)
    // }

  }

  const onDateConfirm = () => {
    const numberOfNights = endDate.diff(startDate, 'day');
    const isDubai = selectedDestination && selectedDestination['Display Name #1']?.includes('Dubai');

    if (isDubai && !(numberOfNights >= 3)) {
      setIsError({ type: 'dubaiError' });
    } else if (isDubai === false && !(numberOfNights >= 3) || numberOfNights < 3) {
      setIsError({ type: 'date' });
    }
    // else if (startDate.isBefore(dayjs().add(10, "day"))) {
    //   setIsError({ type: 'maxDays' });
    // } 
    else if (!hasAgeSelected) {
      setIsError({ type: 'age' });
    } else if (isError?.type && ["date", "dubaiError", "age"].includes(isError.type)) {
      setIsError(null);
    }
  };

  const handleChangeDatePicker = () => {
    // setFirstTimeModalDone({
    //   ...firstTimeModalOpenDone,
    //   date: true,
    // })

    // if (selectedDestination === null) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       date: false,
    //       // destination: true
    //     })
    //   }, 100)
    // } else {
    //   if (!firstTimeModalOpenDone.class) {
    //     setTimeout(() => {
    //       setOpenModals({
    //         ...openModals,
    //         // class: true,
    //         date: false
    //       })
    //     }, 100)
    //   } else if (!firstTimeModalOpenDone.room) {
    //     setTimeout(() => {
    //       setOpenModals({
    //         ...openModals,
    //         date: false,
    //         // room: true
    //       })
    //     }, 100)
    //   }
    //   else {
    //     setTimeout(() => {
    //       setOpenModals({
    //         ...openModals,
    //         date: false
    //       })
    //     }, 100)
    //   }

    // }
  }

  const handleSelectClass = (e: string) => {
    setIsErrors(false)
    if (isError?.type === "class") {
      setIsError(null);
    }
    set_cabin_class(e as unknown as keyof CABIN_CLASS_ENUM_TYPE)

    // setFirstTimeModalDone({
    //   ...firstTimeModalOpenDone,
    //   class: true
    // })

    // if (selectedDestination === null) {
    //   setTimeout(() => {
    //     setOpenModals({
    //       ...openModals,
    //       // destination: true,
    //       class: false
    //     })
    //   }, 100)
    // } else {
    //   if (!firstTimeModalOpenDone.room) {
    //     setTimeout(() => {
    //       setOpenModals({
    //         ...openModals,
    //         class: false,
    //         // room: true
    //       })
    //     }, 100)
    //   } else {
    //     setTimeout(() => {
    //       setOpenModals({
    //         ...openModals,
    //         class: false,
    //       })
    //     }, 100)
    //   }
    // }
  }

  const onOpenDatePicker = () => {
    setTimeout(() => {
      let obj: any = { ...openModals }
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          obj[key] = false;
        }
      }

      obj["date"] = true;

      // setOpenModals(obj)
    }, 10)
  }

  const onCloseDatePicker = () => {
    setOpenModals({
      ...openModals,
      date: false
    })
  }

  const GuestComponent = useMemo(() => {
    return <GuestDropdown
      setRoom={setRoom}
      room={room}
      totalInfantsChildren={totalInfantsChildren}
      totalChildren={totalChildren}
      guestRoomSubmit={guestRoomSubmit}
      selectedDestination={selectedDestination}
      handleFind={handleFind}
    />
  }, [room, totalChildren, selectedDestination])
  let displayText = selectedDestination
    ? `${selectedDestination["Display Name #1"]} ${selectedDestination["airport_code"]}`
    : "";
  displayText = displayText?.slice(0, -3) + displayText?.slice(-3).toUpperCase();
  return (
    <>
      <Box
        display='flex'
        alignItems='flex-end'
        flexWrap={{ xl: 'nowrap', xs: 'wrap' }}
        justifyContent={{ xl: 'space-between', xs: 'none' }}
      // position={{ xs: 'sticky', lg: 'static' }}
      >
        {editSearch && windowWidth < 600 ? (
          <Box sx={{
            width: '100%',
          }}>
            <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px' >
              Edit Search
            </Typography>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px',
                border: `0.8px solid ${colors.grey[30]}`,
                borderRadius: '5px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: colors.basics.primary,
                  backgroundColor: colors.basics.secondary,
                },
              }}
              onClick={() => {
                window.scrollTo({ top: 50, behavior: 'smooth' });
                dispatch(setEditSearch(false))
              }}
            >
              <Typography
                variant='body1'
                fontSize="14px"
                fontWeight={400}
                lineHeight='130%'
                color={colors.basics.black}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  minWidth: 0,
                  gap: '4px',
                  overflow: 'hidden',
                }}
                component="span"
              >
                <Box
                  component="span"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    flex: '0 1 auto',
                    minWidth: 0,
                  }}
                >
                  {displayText}
                </Box>
                <Box
                  component="span"
                  sx={{
                    color: colors.grey[30],
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    fontSize: '14px',
                  }}
                >
                  • {startDate.format('DD MMM YY')} - {endDate.format('DD MMM YY')}
                </Box>
              </Typography>

              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                ml: '8px',
              }}>
                <ArrowDownIcon />
              </Box>
            </Box>
          </Box>
        ) : (
          <Grid container columnSpacing={1} justifyContent={{ xl: 'space-between', xs: 'none' }}>
            <Grid xl={3} lg={4} md={4} xs={12} sm={6} item>
              <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px' >
                Destination
              </Typography>
              <Box position={'relative'} sx={{
                '& .css-r4743b ': {
                  mr: "px"
                },

              }}>
                <AutoComplete
                  openModals={openModals}
                  keys={"destination"}
                  setOpenModals={setOpenModals}
                  data={destinations}
                  StartIcon={<ListingLocationIcon />}
                  value={displayText}
                  disableClearable
                  onInputChange={(inputValue) => {
                    setDestinationInputValue(inputValue);
                  }}
                  onChange={(value) => {
                    // Reset input value when destination is selected
                    setDestinationInputValue('');
                    const selectedDest = isLlcFeatureRequiredNotRequiredDestinations.find((dest: any) => {
                      return `${dest["Display Name #1"]} ${dest["airport_code"]}` === value;
                    });
                    let data = process.env.REACT_APP_PROJECT_COUNTRY === "ie"
                      ? [...IE_DEPARTURE]
                      : process.env.REACT_APP_PROJECT_COUNTRY === "us"
                        ? [...US_DEPARTURE]
                        : [...UK_DEPARTURE];
                    if (selectedDest?.restrictedDepartures && selectedDest?.restrictedDepartures?.length > 0) {
                      data = data.filter(item => !selectedDest?.restrictedDepartures?.includes(item.departure_airport));
                    }

                    const currentSelectedDeparture = departure?.find((d) => d.selected) || flightRoom.searchCriteria.departure;

                    let hasMatch = false;

                    data = data.map((item) => {
                      const isMatch =
                        currentSelectedDeparture?.full_name === item.full_name ||
                        currentSelectedDeparture?.departure_airport === item.departure_airport;
                      if (isMatch) hasMatch = true;
                      return {
                        ...item,
                        selected: isMatch,
                      };
                    });

                    if (!hasMatch && data.length > 0) {
                      const defaultAirport = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? "DUB" : "LON";
                      data = data.map((item) => ({
                        ...item,
                        selected: item.departure_airport === defaultAirport,
                      }));
                    }

                    setDeparture(data)

                    const selectedDepartureData = data.find((item) => item.selected);

                    // keep your region logic
                    // process.env.REACT_APP_PROJECT_COUNTRY === "ie"
                    //   ? dispatch(setSelectedRegion(phoneCodeByRegionIE?.find((dest: any) => dest.Destination === value.split(',')                      [0])))
                    //   : dispatch(setSelectedRegion(phoneCodeByRegionUK?.find((dest: any) => dest.Destination === value.split(',')[0])));

                    handleOnChangeDestination(value, selectedDepartureData);
                  }}
                />
                {/* <AutoComplete
                openModals={openModals}
                keys={"destination"}
                setOpenModals={setOpenModals}
                data={destinations}
                StartIcon={<LocationOnIcon sx={{ color: colors.basics.primary }} />}
                value={displayText}
                disableClearable
                onChange={(value) => {
                  {
                    process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? dispatch(setSelectedRegion(phoneCodeByRegionIE?.find((dest: any) => dest.Destination === value.split(',')[0]))) :
                      dispatch(setSelectedRegion(phoneCodeByRegionUK?.find((dest: any                    ) => dest.Destination === value.split(',')[0])))
                  }

                  h                    andleOnChangeDestination(value)
                }}
              /> */                    }
                {isError?.type === 'destination' && <ErrorMessage type={isError.type} />}
              </Box>
            </Grid>
            <Grid xl={2.3} lg={4} md={4} xs={12} pl={{ sm: "16px !important", xs: "8px !important" }} sm={6} item>
              <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px' mt={{ sm: 0, xs: '10px' }}>
                Departure
              </Typography>
              <Box position={'relative'} mt={"10px"} sx={{
                '& .css-r4743b ': {
                  mr: "6px"
                },
                '& .custom-dropdown-listing-page .dropdown-toggle span': {
                  // maxWidth: "calc(100% - 60px)"
                },
                '& .custom-dropdown-listing-page .dropdown-menu': {
                  top: "-2px !important",
                  left: "-1px !important",
                  boxShadow: "0px 1px 6px -2px rgba(0,0,0,0.3) !important",
                },
                '& .MuiButtonBase-root-MuiMenuItem-root': {
                  padding: "8px 8px !important",
                },
              }}>
                <CustomSelectInputListingPage
                  ids={"departure"}
                  keys={"departure"}
                  // menuHeading="Airports for departure"
                  // showCheckmark={true}
                  // dropdownWidth={"100%"}
                  menuStyle={{
                    maxHeight: 350,
                    minWidth: windowWidth < 576 ? "286px" : "280px",
                    ...(windowWidth < 576 ? { right: "0px" } : { left: "0px", } as any),
                  }}
                  // className={`dropdown-menu ${departure?.find(({ selected }) => selected)?.full_name ? 'show' : ''}`}
                  StartIcon={<PlaneListIcon />}
                  value={departure?.find(({ selected }) => selected)?.full_name || ''}
                  paddingStyle="0px"
                  radiusStyle="5px"
                  children={departure && departure.length > 0 ? (
                    <DepartureDropdownContent />
                  ) : (
                    // <MenuItem disabled sx={{ cursor: "auto !important" }}>
                    <Typography variant="body2" color={colors.basics.primary} fontSize={{ sm: '15px', xs: '14px' }}>
                      Departure not found
                    </Typography>
                    // </MenuItem>
                  )}

                />
                {isError?.type === 'departure' && <ErrorMessage type={isError.type} />}
              </Box>
            </Grid>

            <Grid xl={2.2} lg={4} md={4} xs={12} sm={6} pl={{ xl: "16px !important", md: "16px !important", sm: "8px !important", xs: "8px !important" }} item mt={'3px'}>
              <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px'
                mt={{ md: '0 ', sm: '10px', xs: '10px' }}
              >
                When
              </Typography>
              <Box position='relative'>
                <CustomeDatePicker
                  heading="When are you leaving?"
                  initialDates={[
                    new DateObject().add(7, 'days'),
                    new DateObject().add(14, 'days'),
                  ]}
                  isButtonShown={windowWidth < 769 ? false : false}
                  onCloseDatePicker={onCloseDatePicker}
                  onOpenDatePicker={onOpenDatePicker}
                  datePickerRef={datePickerRef}
                  handleChangeDatePicker={handleChangeDatePicker}
                  openModals={openModals}
                  setOpenModals={setOpenModals}
                  setDate={(date: any) => setDate(date)}
                  date={date}
                  onDateConfirm={onDateConfirm}
                  // numberOfMonths={windowWidth > 1023 ? 2 : 1}
                  numberOfMonths={1}
                  range={true}
                  format={'DD MMM YY'}
                  setRangeUpdate={setRangeUpdate}
                />
                {(isError?.type === 'date' || isError?.type === 'dubaiError') && (
                  <ErrorMessage type={isError.type} />
                )}
              </Box>
            </Grid>



            <Grid sx={{
              '& .custom-dropdown-listing-page': {
                marginTop: 0
              }
            }} xl={1.9} lg={4} md={4} xs={12} pl={{ xl: "16px !important", md: "8px !important", sm: "16px !important", xs: "8px !important" }} sm={6} item >
              <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px' mt={{ xl: "0", lg: "10px", xs: '10px' }}>
                Room(s)
              </Typography>
              <Box sx={{
                position: 'relative',
                '& .MuiPaper-elevation': {
                  maxHeight: "500px !important",
                  overflow: "auto"
                },
                '& .guest-dropdown': {
                  top: '-1px !important',
                },
                '& .custom-dropdown-listing-page .dropdown-menu': {
                  top: "-3px !important",
                  right: { lg: "1px !important", xs: "2px !important" },
                  minWidth: { xl: "360px", xs: "100%" },
                },

              }}>
                <CustomSelectInputListingPage
                  className='guest-dropdown'
                  identifyKey="rooms"
                  // menuHeading="How many guests?"
                  menuStyle={{
                    maxHeight: "321px",
                    // maxWidth: windowWidth < 576 ? "286px" : "318px",
                    // minWidth: { lg: "360px", md: "318px", xs: "100%" } as any,
                  }}

                  dropdownWidth={windowWidth < 576 ? "286px" : "321px"}
                  ids={"rooms"}
                  // setOpenModals={setOpenModals}
                  keys={"room"}
                  // openModals={openModals}
                  value={`${room.length}  ${room.length >= 2 ? "Rooms" : "Room"} / ${totalGuests} ${(totalGuests) > 1 ? "Guests" : "Guest"}`}
                  StartIcon={
                    <Box height='24px' width='24px' display='flex' justifyContent='center' alignItems='center'>
                      <GuestsIcon />
                    </Box>
                  }
                >{GuestComponent}
                </CustomSelectInputListingPage>
                {isError?.type === 'age' && <ErrorMessage type={isError.type} />}
                {isError?.type === 'infantAge' && <ErrorMessage type={isError.type} />}
                {isError?.type === 'guest' && <ErrorMessage type={isError.type} />}

              </Box>
            </Grid>
            <Grid
              xl={1.6}
              lg={4}
              md={4}
              xs={12}
              sm={6}
              item
              pl={{ xl: "16px !important", md: "16px !important", sm: "8px !important", xs: "8px !important" }}
              sx={{
                position: "relative",
                '&>.MuiInputBase-root': {
                  whiteSpace: 'pre',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%',
                },
                '& .custom-dropdown-listing-page .dropdown-menu': {
                  top: "-2px !important",
                  right: "1px !important",
                  boxShadow: "0px 1px 6px -2px rgba(0,0,0,0.3) !important",
                },
              }}
            >
              <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]} mb='8px' mt={{ xl: "0", lg: "10px", xs: '10px' }}>
                Class
              </Typography>
              <CustomSelectInputListingPage
                ids={"class"}
                paddingStyle="0px"
                radiusStyle="5px"
                dropdownWidth={"100%"}
                // setOpenModals={setOpenModals}
                keys={"class"}
                // openModals={openModals}
                // data={Object.keys(CABIN_CLASS_ENUM)}
                children={<ClassDropdownContent />}
                // menuOnClick={(e: any) => handleSelectClass(e)}
                // onChange={(e) => handleSelectClass(e)}
                value={cabin_class}
                multiple={false}
                StartIcon={<SeatIcon />}
                checkbox={false}
              // menuItemIcon={<SeatIcon />}
              />
              {(isError?.type === 'class') && (
                <ErrorMessage type={isError.type} />
              )}
            </Grid>
            <Grid xl={1} lg={4} md={4} sx={{ width: { sm: 'auto', xs: '100%' } }} sm={4} pl={{ sm: "16px !important", xs: "8px !important" }} item>
              <Button disabled={rangeUpdate}
                className='btn-olb-search-dest'
                sx={{
                  height: '43px',
                  mb: '2px',
                  mt: { xl: "29px", md: '38px', sm: "40px", xs: '20px' },
                  width: { xl: '100%', sm: "auto", xs: '100%' },
                  backgroundColor: rangeUpdate ? '#f89177 !important' : colors.basics.primary,
                  color: rangeUpdate ? `${colors.basics.white} !important` : colors.basics.white,
                  cursor: rangeUpdate ? 'none' : "pointer"
                }}
                onClick={handleFind}
              >
                Search
              </Button>
              {
                holidayPackage?.Packages?.results?.length > 0 &&
                <Box display={{ xs: 'flex', sm: 'none' }} alignItems='center' gap='4px' my='8px' onClick={() => {
                  window.scrollTo({ top: 170, behavior: 'smooth' });
                  dispatch(setEditSearch(!editSearch))
                }}>
                  <Typography variant='body1' fontWeight={700} lineHeight='130%' color={colors.grey[10]}  >
                    Hide Search
                  </Typography>
                  <ArrowDownIcon style={{ transform: 'rotate(180deg)' }} />
                </Box>
              }

            </Grid>
          </Grid>
        )}
      </Box >
    </>
  );
};

export default FindHolidayWidget;
